import React from "react";
import Box from "@mui/material/Box";
import { Fonts } from "../../constants/AppEnums";

interface BadgeProps {
  className?: string;
  count: number;
  color?: string;
}

const AppBadge: React.FC<BadgeProps> = ({ count, color = "secondary" }) => {
  const getCountStr = () => {
    if (count > 99) {
      return "99+"
    } else {
      return count.toString();
    }
  };

  if (color === "primary") {
    color = "primary.main";
  } else if (color === "v") {
    color = "secondary.main";
  }
  return (
    <Box
      className="menu-badge"
      sx={{
        bgcolor: color,
        fontSize: 11,
        fontWeight: Fonts.SEMI_BOLD,
        height: 24,
        minWidth: 24,
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: (theme) => theme.palette.secondary.contrastText,
      }}
    >
      {getCountStr()}
    </Box>
  );
};

export default React.memo(AppBadge);
